import { oidcEarlyInit } from "oidc-spa/entrypoint";
const { shouldLoadApp } = oidcEarlyInit({
    freezeFetch: true,
    freezeXMLHttpRequest: true,
    freezeWebSocket: true,
    freezePromise: undefined,
    safeMode: undefined,
    BASE_URL: "/"
});

if(shouldLoadApp){
    import("./main.tsx?oidc-spa-original=true");
}